import status from 'http-status';

import { questionLibraryConstants as constants } from '../_constants/question-library.constants';
import { questionLibraryService as service } from '../_services/question-library.service';
import { alertActions } from './alert.actions'
import { history } from '../_helpers/history';

export function initState() {
  return { type: constants.QUESTION_INIT_STATE }
}

export function setChoiceType(choiceType) {
  return { type: constants.SET_CHOICE_TYPE, choiceType };
}

export function updateOption(option, position) {
  return { type: constants.UPDATE_OPTION, option, position };
}

export function removeOption(option) {
  return { type: constants.REMOVE_OPTION, option };
}

export function addOption(item, option) {
  return { type: constants.ADD_OPTION, item, option };
}

export function setQuestionType(typeId) {
  return { type: constants.SET_FIELD_TYPE, typeId }
}

export function cancelQuestion() {
  return { type: constants.CANCEL }
}

export function setText(text) {
  return { type: constants.SET_TEXT, text };
}

export function setSupportImage(item, url) {
  return { type: constants.QUESTION_SET_SUPPORT_IMAGE, item, url };
}

export function setSupportLink(item, url) {
  return { type: constants.QUESTION_SET_SUPPORT_LINK, item, url };
}

export function saveQuestion() {
  return (dispatch, getState) => {
    const store = getState().questionLibrary;

    dispatch(request());

    service.save(store.current)
      .then((response) => {
        dispatch(success(response.data));
        history.push('/questions');

        dispatch(alertActions.success('Question saved to the library!'));
      })
      .catch((error) => {
        if (error.response) {
          dispatch(failure());

          if (error.response.status === status.UNPROCESSABLE_ENTITY) {
            for (const validation in error.response.data) {
              dispatch(alertActions.error(error.response.data[validation]));
            }
          } else {
            dispatch(alertActions.error("Could not save the question at this time. Please try again."));
          }
        }

      });
  }

  function request() { return { type: constants.SAVE_QUESTION_REQUEST } }
  function success() { return { type: constants.SAVE_QUESTION_SUCCESS } }
  function failure() { return { type: constants.SAVE_QUESTION_FAILURE } }
}

export function get(id) {
  return dispatch => {
    dispatch(request());

    service.get(id)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        history.push('/questions');

        dispatch(alertActions.error("Could retrieve the question at this time. Please try again."));
      });
  }

  function request() { return { type: constants.GET_QUESTION_REQUEST } }
  function success(question) { return { type: constants.GET_QUESTION_SUCCESS, question } }
}

export function getQuestionsByProvider() {
  return dispatch => {
    dispatch(request());

    service.getByProvider()
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could retrieve the questions at this time. Please try again."));
      });
  }


  function request() { return { type: constants.GETALL_QUESTIONS_REQUEST } }
  function success(collection) { return { type: constants.GETALL_QUESTIONS_SUCCESS, collection } }
}

export function cancelEdit() {
  return dispatch => {
    dispatch({ type: constants.CANCEL_EDIT });

    return Promise.resolve();
  }
}

export function setPromptWarning(flag) {
  return dispatch => {
    dispatch({ type: constants.QUESTION_SET_PROMPT_WARNING, flag });

    return Promise.resolve();
  }
}
